/**
 * External dependencies
 */

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

export default function save( ) {
	return <InnerBlocks.Content />;
}

